import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {noop} from 'lodash';

import {Reports} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import styles from './ClearFilter.style';
import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';
interface ClearFilterProps {
  text: string;
  setGenerationOptions: () => void;
  setProductsOptions: () => void;
  setAccountStatusOptions: () => void;
  productItems: any[];
  generationItems: any[];
  accountStatusItems: any[];
  setGenerationWithoutFilter: () => void;
  setProductsWithoutFilter: () => void;
  setAccountWithoutFilter: () => void;
}
export const ClearFilter: React.FC<ClearFilterProps> = ({
  text = '',
  generationItems = [],
  productItems = [],
  accountStatusItems = [],
  setGenerationOptions = noop,
  setProductsOptions = noop,
  setAccountStatusOptions = noop,
  setGenerationWithoutFilter = noop,
  setProductsWithoutFilter = noop,
  setAccountWithoutFilter = noop,
}) => {
  const {isReadyToLoad} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  const handleClearFiltersPress = () => {
    setGenerationOptions(generationItems);
    setProductsOptions(productItems);
    setAccountStatusOptions(accountStatusItems);

    setGenerationWithoutFilter(null);
    setProductsWithoutFilter(null);
    setAccountWithoutFilter(null);
  };

  if (!isReadyToLoad) {
    return null;
  }

  const accessibilityLabel = (text || 'Clear filters').trim();

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={handleClearFiltersPress}
        accessible={true}
        focusable={true}
        importantForAccessibility="yes"
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel}
        style={styles.button}
        {...testProperties(Reports.reportFilterClearFiltersView)}>
        <View style={styles.buttonStyle}>
          <Text
            style={styles.buttonText}
            {...testProperties(Reports.reportFilterClearFiltersButton)}>
            {text}
          </Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};
